// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { red, amber, cyan, green, grey } from '@mui/material/colors';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //
const contrastText = '#fff';

const getDesignTokens = (mode) => ({
    palette: {
        mode, // Add mode to palette so components can access it
        ...(mode === 'light'
            ? {
                  // palette values for light mode
                  common: {
                      black: '#000',
                      white: '#fff'
                  },
                  primary: {
                      lighter: green[50],
                      100: green[100],
                      200: green[200],
                      light: green[300],
                      400: green[400],
                      main: green[600],
                      dark: green[700],
                      700: green[700],
                      darker: green[800],
                      900: green[900]
                  },
                  secondary: {
                      lighter: cyan[100],
                      100: cyan[100],
                      200: cyan[200],
                      light: cyan[300],
                      400: cyan[400],
                      main: cyan[500],
                      600: cyan[600],
                      dark: cyan[700],
                      800: cyan[800],
                      darker: cyan[900],
                      A100: cyan[50],
                      A200: cyan[400],
                      A300: cyan[700],
                      contrastText: contrastText
                  },
                  error: {
                      lighter: red[50],
                      light: red[200],
                      main: red[400],
                      dark: red[700],
                      darker: red[900],
                      contrastText
                  },
                  warning: {
                      lighter: amber[50],
                      light: amber[300],
                      main: amber[500],
                      dark: amber[700],
                      darker: amber[900],
                      contrastText: grey[100]
                  },
                  info: {
                      lighter: cyan[50],
                      light: cyan[300],
                      main: cyan[500],
                      dark: cyan[700],
                      darker: cyan[900],
                      contrastText
                  },
                  success: {
                      lighter: green[50],
                      light: green[300],
                      main: green[500],
                      dark: green[700],
                      darker: green[900],
                      contrastText
                  },
                  text: {
                      primary: grey[900],
                      secondary: grey[700],
                      disabled: grey[400],
                      // In light mode, this can be the same as primary since light backgrounds use dark text
                      primaryOnLight: grey[900]
                  },
                  action: {
                      disabled: grey[300]
                  },
                  divider: grey[200],
                  background: {
                      paper: grey[50],
                      default: grey[50]
                  }
              }
            : {
                  // palette values for dark mode
                  common: {
                      black: '#000',
                      white: '#fff'
                  },
                  primary: {
                      lighter: green[900],
                      100: green[900],
                      200: green[800],
                      light: green[700],
                      400: green[600],
                      main: green[500],
                      dark: green[400],
                      700: green[400],
                      darker: green[300],
                      900: green[200]
                  },
                  secondary: {
                      lighter: cyan[900],
                      100: cyan[900],
                      200: cyan[800],
                      light: cyan[700],
                      400: cyan[600],
                      main: cyan[500],
                      600: cyan[400],
                      dark: cyan[300],
                      800: cyan[300],
                      darker: cyan[200],
                      A100: cyan[900],
                      A200: cyan[600],
                      A300: cyan[300],
                      contrastText: contrastText
                  },
                  error: {
                      lighter: red[400],
                      light: red[600],
                      main: red[700],
                      dark: red[800],
                      darker: red[900],
                      contrastText
                  },
                  warning: {
                      lighter: amber[200],
                      light: amber[600],
                      main: amber[700],
                      dark: amber[800],
                      darker: amber[900],
                      contrastText: grey[500]
                  },
                  info: {
                      lighter: cyan[200],
                      light: cyan[600],
                      main: cyan[700],
                      dark: cyan[800],
                      darker: cyan[900],
                      contrastText
                  },
                  success: {
                      lighter: green[200],
                      light: green[600],
                      main: green[700],
                      dark: green[800],
                      darker: green[900],
                      contrastText
                  },
                  text: {
                      primary: grey[100],
                      secondary: grey[300],
                      disabled: grey[500],
                      // Custom color for elements that need to work against light backgrounds in dark mode
                      primaryOnLight: '#1c1c1c'
                  },
                  action: {
                      disabled: grey[600]
                  },
                  divider: '#424242',
                  background: {
                      paper: '#161616',
                      default: '#1c1c1c'
                  }
              })
    }
});

const Palette = (mode) => {
    return createTheme(getDesignTokens(mode));
};

export default Palette;
